import React from "react";
import { FaInstagram } from "react-icons/fa";
import fetchJsonp from 'fetch-jsonp';
import qs from 'query-string';
import { Redirect } from 'react-router-dom';
import logoS from "../../../assets/images/s-white-on-black-logo.png";


import Step from "../Step";
import StateMachine from "src/components/utils/StateMachine";
import WithUserForm from "../../Register/WithUserForm";

import styles from "../styles.module.css";
import DotWaveLoader from "../../../assets/DotWaveLoader/DotWaveLoader";

const redirectUri =
  window.location.origin + "/apply/instagram".replace("http://", "https://");
const instagramAuthURL = `https://www.instagram.com/oauth/authorize`;


class Form extends React.Component {
  state = {
    showModal: false,
    showVerifyModal: false,
    hasMediaAccess: false,
    accessToken: null,
  };

  componentDidMount() {
    this.getAuthenticateToken();
    this.getAccessToken();
  }

  showVerifyModal = () => {
    this.setState({
      showVerifyModal: true,
    });
    setTimeout(() => {
      this.waitFor((_) => this.state.hasMediaAccess).then((_) =>
        this.setState({ showVerifyModal: false })
      );
    }, 2000);
  };

  waitFor(conditionFunction) {
    const poll = (resolve) => {
      if (conditionFunction()) resolve();
      else setTimeout((_) => poll(resolve), 300);
    };
    return new Promise(poll);
  }

  getAccessToken = async () => {
    const hashString = window.location.search.substr(1, window.location.search.indexOf("&state") - 1);
    if (hashString.startsWith('code')) {
      this.showVerifyModal();
      const accessCode = hashString.substr(5);
      try {
        const response = await this.props.exchangeToken({
          variables: {
            code: accessCode,
            redirectUri
          },
        });
        let userAccessToken = response.data.exchangeToken;
        // Refetch current user to ensure instagramToken is available before proceeding to photo selection
        await this.props.userQuery.refetchCurrentUser();
        this.setState({ accessToken: userAccessToken });
        this.checkMediaAccess();
      }
      catch (error) {
        console.log(error)
      }
    }
  };

  checkMediaAccess = async () => {
    const queryString = qs.stringify({
      access_token: this.state.accessToken,
    });
    const body = await fetchJsonp(
      'https://graph.instagram.com/v21.0/me/media/?' + queryString
    ).then((res) => res.json())
    .catch (error => console.log(error));

    if (!body.hasOwnProperty('error')) {
      this.setState({ hasMediaAccess: true });
    }
  };

  getAuthenticateToken = () => {
    const hashString = window.location.search.substr(window.location.search.indexOf("state="));
    const authToken = hashString.substr(6);

    if (!window.localStorage.getItem("token")) {
      window.localStorage.setItem("token", authToken);
    }
  }

  render() {
    const hashString = window.location.search.substr(1);

    if ( !this.state.showVerifyModal && this.state.hasMediaAccess ) {
      return <Redirect to='/apply/photos' />;
    }

    return (
      <StateMachine.Consumer>
        {() => {
          const footer = (
              <>
                {!this.state.showVerifyModal && <p className={`${styles.contact_us_link} ${styles.default_text_size}`} style={{color: '#B08D57'}}>
                  Having trouble? <a
                    href="https://wa.me/447588663357"
                    style={{color: '#B08D57', textDecoration: 'underline', fontWeight: 'bold'}}>Contact us</a>.
                </p>}
              </>
          );
          return (<Step footer={footer}>
            <form
              action={instagramAuthURL}
              method="GET"
              className='w-full flex flex-col items-center'
            >
              <input
                type="hidden"
                name="client_id"
                value={process.env.REACT_APP_SCHMODEL_INSTAGRAM_APP_ID}
              />
              <input type="hidden" name="redirect_uri" value={redirectUri} />
              <input
                type="hidden"
                name="scope"
                value="instagram_business_basic"
              />
              <input type="hidden" name="response_type" value="code" />
              <input
                type="hidden"
                name="state"
                value={window.localStorage.getItem("token")}
              />
              {hashString?.startsWith("error") && (
                  <div
                      style={{
                        color: "#e04344",
                        fontSize: 'clamp(9px, 2vh, 13px)',
                        width: '100%',
                        textAlign: "center"
                      }}
                  >
                    <strong style={{ display: "inline" }}>Oops! </strong>
                    Your IG connection failed. Make sure you<br />
                    click ‘Allow’ when prompted. Please try again.
                  </div>
              )}
              <div className={`${styles.content}`}>
                To verify your identity and allow you access<br />
                to Schmodel services, IG will connect your<br />
                account for ID validation and media access <br />
                (allowing you to upload profile images).
                <br />
                <br />
                This allows us to confirm your Instagram<br />
                identity and allow you access to all services.
                <br />
                <br />
                No private information is shared with us <br />
                that isn't already publicly available. <br />
                You can access <a href="https://www.instagram.com/oauth/info_sharing_disclaimer/?use=login" target="_blank" rel="noopener noreferrer" style={{ color: '#B08D57' }}>Instagram's T&C's</a>.
                <br />
                <br />
                Instagram does not allow private accounts<br />
                to connect - you must have (or change to) a<br />
                professional account (business or creator).
                <br />
                <br />
                You will be prompted for media access in <br />
                order to upload 6 Instagram posts of your <br />
                choice that best represent you and your work.
              </div>
              <button
                  className={`${styles.wrap_instagram}`}
              >
                <FaInstagram size={25} />
                CONNECT TO INSTAGRAM
              </button>
              {this.state.showVerifyModal && (
                <div className={styles.verifyingOverlay}>
                  <div className={styles.verifyingContent}>
                    <h2 className={styles.verifyingTitle}>VERIFYING<br />PROFILE</h2>
                    <div className={styles.loaderContainer}>
                      <FaInstagram size={40} className={styles.loaderIcon} />
                      <DotWaveLoader />
                      <div className={styles.loaderS}>
                        <img src={logoS} className='h-full' alt="logo"/>
                      </div>
                    </div>
                    <p className={styles.verifyingText}>
                      Please wait while Instagram<br />confirms your profile
                    </p>
                  </div>
                </div>
              )}
            </form>
          </Step>
        )}}
      </StateMachine.Consumer>
    );
  }
}

class AccessInstagram extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVerifyModal: false,
      hasMediaAccess: false,
      accessToken: null,
    };
  }

  render() {
    return <WithUserForm
      render={(props) => <Form {...props} />}
    />;
  }
}

export default AccessInstagram;
